<template>
    <div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

        <label htmlFor="input">
            <b>{{$t(label)}}</b>
            <slot name="label"></slot>
        </label>

        <div class="input-group">
            <calendar :locale="locale" :date-format="dateFormat" style="width: 100%;" :class="['coff-calendar', { 'p-error' : error }]" :show-icon="true" :show-buttonBar="true" v-model="dateValue" :key="'calendar'+uuid"
                      v-mask="getMask(type)" :min-date="minDate" :max-date="maxDate" :manual-input="true" :year-navigator="true" :year-range="yearRange" :month-navigator="true" :disabled="disabled" :showTime="showTime"/>
            <span v-if="error">{{ $t(errorMessage)}}</span>
        </div>

    </div>
</template>

<script>
    import Utils from "@/utils/Utils";
    import {mask} from 'vue-the-mask';
    import MaskUtil from "@/utils/MaskUtil";

    export default {
        name: "CoffInputCalendar",

        directives: {mask},

        props:{
            label: {type: String, default: null},
            value: null,
            error: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            showTime: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            type: {type: String, default: 'date', options: 'date' || 'time' || 'datetime'},
            minDate: {
                type: Date,
                value: null
            },
            maxDate: {
                type: Date,
                value: null
            },
        },

        data(){
            return {
                uuid: Utils.uuid(),
                dateValue: this.value,
                locale: {
                    firstDayOfWeek: 0,
                    dayNames: [
                        this.$t('locale.dayNames.sunday'), this.$t('locale.dayNames.monday'), this.$t('locale.dayNames.tuesday'), this.$t('locale.dayNames.wednesday'),
                        this.$t('locale.dayNames.thursday'), this.$t('locale.dayNames.friday'), this.$t('locale.dayNames.saturday')
                    ],
                    dayNamesShort: [
                        this.$t('locale.dayNamesShort.sunday'), this.$t('locale.dayNamesShort.monday'), this.$t('locale.dayNamesShort.tuesday'), this.$t('locale.dayNamesShort.wednesday'),
                        this.$t('locale.dayNamesShort.thursday'), this.$t('locale.dayNamesShort.friday'), this.$t('locale.dayNamesShort.saturday')
                    ],
                    dayNamesMin: [
                        this.$t('locale.dayNamesMin.sunday'), this.$t('locale.dayNamesMin.monday'), this.$t('locale.dayNamesMin.tuesday'), this.$t('locale.dayNamesMin.wednesday'),
                        this.$t('locale.dayNamesMin.thursday'), this.$t('locale.dayNamesMin.friday'), this.$t('locale.dayNamesMin.saturday')
                    ],
                    monthNames: [
                        this.$t('locale.monthNames.january'), this.$t('locale.monthNames.february'), this.$t('locale.monthNames.march'), this.$t('locale.monthNames.april'),
                        this.$t('locale.monthNames.may'), this.$t('locale.monthNames.june'), this.$t('locale.monthNames.july'), this.$t('locale.monthNames.august'),
                        this.$t('locale.monthNames.september'), this.$t('locale.monthNames.october'), this.$t('locale.monthNames.november'),this.$t('locale.monthNames.december')
                    ],
                    monthNamesShort: [
                        this.$t('locale.monthNamesShort.january'), this.$t('locale.monthNamesShort.february'), this.$t('locale.monthNamesShort.march'), this.$t('locale.monthNamesShort.april'),
                        this.$t('locale.monthNamesShort.may'), this.$t('locale.monthNamesShort.june'), this.$t('locale.monthNamesShort.july'), this.$t('locale.monthNamesShort.august'),
                        this.$t('locale.monthNamesShort.september'), this.$t('locale.monthNamesShort.october'), this.$t('locale.monthNamesShort.november'),this.$t('locale.monthNamesShort.december')
                    ],
                    today: this.$t('locale.today'),
                    clear: this.$t('locale.clear'),
                    dateFormat: this.$t('locale.dateFormat'),
                    weekHeader: this.$t('locale.weekHeader'),
                }
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },

        watch: {
            value(newValue) {
                this.dateValue = newValue;
            },

            dateValue(newValue) {
                if (newValue instanceof Date) {
                    this.$emit('input', newValue);
                } else if (Utils.isEmptyNullOrUndefined(newValue)) {
                    this.$emit('input', null);
                }
            }
        },

        computed: {

            dateFormat(){
                return this.$t('locale.dateFormat');
            },

            yearRange(){
                return '1500:'+(new Date().getFullYear() + 100);
            }

        },

        methods: {
            getMask: MaskUtil.mask,
        }

    }
</script>

<style lang="scss">

    .coff-calendar, .p-autocomplete.p-autocomplete-multiple .p-autocomplete-multiple-container {
            width: 100%;
    }



</style>